// extracted by mini-css-extract-plugin
export var container = "textarea-module--container--EGql+";
export var error = "textarea-module--error--PRt8+";
export var errorMessage = "textarea-module--errorMessage--wt5GK";